<div class="product-grid">
    <!-- Iteramos sobre el array de productos -->
    <div *ngFor="let producto of arrayProductos" class="product-card">
  
      <!-- Contenedor de la Imagen -->
      <div class="d-flex img-container">
        <img [src]="producto.imagenUrl"    [alt]="producto.strDescripcion  || 'Imagen de producto'"     
        class="w-90 mx-auto"loading="lazy"   >
      </div>
  
      <!-- Contenedor de la Información -->
      <div class="product-info">
        <h3 class="product-description text-ellipsi fs12">{{ producto.strDescripcion  || 'Producto sin descripción' }}</h3>
        <p class="product-key">Clave: <strong>{{ producto.strArticulo || 'N/A' }}</strong></p>
        <!-- <p class="product-price nunito fw-bold">  <strong>{{ producto.dblPrecioLista  | currency }}</strong></p> -->
      </div>
  
      <!-- Botón de Compra -->
      <button class="buy-button d-flex justify-content-center align-items-center" (click)="comprarProducto(producto)">
        <mat-icon class="fs-6 d-flex justify-content-end align-items-center">shopping_cart</mat-icon> <span class="fs13"> Comprar ahora</span>
      </button>
    </div>
  
    <!-- Mensaje si no hay productos -->
    <div *ngIf="!arrayProductos || arrayProductos.length === 0" class="no-products">
      No hay productos para mostrar.
    </div>
  </div>
